import { render } from "./shareApply.vue?vue&type=template&id=2d9d6056&scoped=true"
import script from "./shareApply.vue?vue&type=script&lang=js"
export * from "./shareApply.vue?vue&type=script&lang=js"

import "./shareApply.vue?vue&type=style&index=0&id=2d9d6056&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9d6056"]])

export default __exports__